module.exports = __webpack_public_path__ + "static/media/Kingmaker Thumbnail.889535f4.png";